import { toastr } from "react-redux-toastr";
import * as actionTypes from "./actionTypes";
import { appLoading, appSuccess, appError } from "./appActions";
import { login, logout } from "../../api/authApi";
import LocalStorageService from "../../services/LocalStorageService";
import { isAdminUser } from "../../services/utils";
import { trackEvent } from "../../utils/trackEvent";
import { resetTempUserInfo } from "../../features/habitation/userSlice";
import { reset as resetHabitation } from "../../features/habitation/habitationSlice";
import { setDatadogUser } from "../../services/datadog";

export const authSuccess = (data) => ({
  type: actionTypes.AUTH_SUCCESS,
  payload: data,
});

export const authFailed = (error) => ({
  type: actionTypes.AUTH_FAILED,
  payload: error,
});

export const authLogout = () => ({
  type: actionTypes.AUTH_LOGOUT,
});

export const loginUser = (payload) => (dispatch) => {
  const userTmp = {
    username: payload.user.email,
    password: payload.user.password,
  };
  const { user, history, redirectUrl } = payload;

  dispatch(appLoading());

  login(userTmp)
    .then((response) => {
      const { data } = response;

      if (!data || !data.user) {
        throw new Error('User data not found in response');
      }

      const userData = data.user;

      // Store user data in localStorage
      const localStorageService = LocalStorageService.getService();
      localStorageService.setUser(data);

      dispatch(appSuccess());
      dispatch(authSuccess({
        data: data,
        token: null
      }));

      // Redirect after successful login
      setTimeout(() => {
        if (redirectUrl) {
          history.push(redirectUrl);
        } else if (isAdminUser(userData)) {
          history.push("/schools");
        } else {
          history.push("/home");
        }
      }, 0);

      // Track login event
      try {
        trackEvent('login', {
          user_data: {
            email: userData.email || '',
            first_name: userData.name || '',
            last_name: userData.lastName || '',
          },
          user_roles: userData.roles || [],
        });
      } catch (trackError) {
        console.error('Error tracking login:', trackError);
      }

      // Set Datadog user context for better error tracking
      try {
        setDatadogUser(userData);
      } catch (ddError) {
        console.error('Error setting Datadog user:', ddError);
      }

    }).catch((error) => {
      console.error('Login error:', error);
      dispatch(appError(error));
      dispatch(authFailed(error));

      // Show error message to user
      const errorMessage = error?.response?.data?.message || error?.message || 'Une erreur est survenue lors de la connexion';
      toastr.error('Erreur', errorMessage);
    });
};


// Helper function to delete all auth cookies
const deleteAllCookies = () => {
  const cookies = document.cookie.split(";");

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();

    // Delete cookie for current domain
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    // Delete cookie for parent domain
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=" + window.location.hostname;
    // Delete cookie with secure flag
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;secure";
  }

  console.log('🍪 All cookies deleted');
};

export const logoutUser = () => async (dispatch) => {
  try {
    // Call backend logout API to invalidate session
    await logout();

    // Clear localStorage
    const service = LocalStorageService.getService();
    service.clearUser();
    service.removeHealthMobilityContract();

    // Clean up Redux states
    dispatch(authLogout());
    dispatch(resetTempUserInfo());
    dispatch(resetHabitation());

    // Delete frontend cookies (analytics, tracking, etc.)
    deleteAllCookies();

    // Clear Datadog user context
    try {
      setDatadogUser(null);
    } catch (ddError) {
      console.error('Error clearing Datadog user:', ddError);
    }

    // Only redirect if not already on login page
    if (!window.location.pathname.includes('/login')) {
      window.location.assign('/login/classic');
    }

  } catch (e) {
    console.error('Logout error:', e);
    dispatch(appError(e));

    // Still clean up and redirect even on error
    deleteAllCookies();
    setDatadogUser(null);
    if (!window.location.pathname.includes('/login')) {
      window.location.assign('/login/classic');
    }
  }
};